import './DocAdministartionClientsidebarstyle.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import {Outlet } from 'react-router-dom';

//import { Link, Outlet, useLocation } from 'react-router-dom';
//import useUtilities from '../../../hooks/useUtilities';

function DocAdmininstratifClientSidebar() {

    const { i18n } = useTranslation();

    //const {pathname} = useLocation();
    //const curPath = pathname.split('/').pop();

    return (
        <>
            <div className='frame5Profile'> {i18n.t('Compte entreprise')}&gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Documents administratifs')}</span> </div>
            {/*<div className={sideBarOpen ?'wholepageocrstyleOpen':'wholepageocrstyle'}>*/}
            {/*<div className = 'menuglobalstyle'>
                    {/*<div className='cardidselectedmenustyle'>
                        <Link
                            to="."
                            style= {{ textDecoration: 'none' }}
                        >
                            <p className='textcardidstyle'>Contrat HTH</p>
                        </Link></div>
                    <div className='contratmenustyle'>
                        <Link
                            to="kbis"
                            style= {{ textDecoration: 'none' }}
                        >
                            <p className='textotherstyle'>KBIS</p>
                        </Link>
                    </div>
                </div>*/}
            <Outlet />
            {/*</div>*/}
        </>
    );
}

export default DocAdmininstratifClientSidebar;

//);
//case 'kbis':
//    return (
//        <div className='wholepageocrstyle'>
//            <div className = 'menuglobalstyle'>
//                <div className='cardidmenustyle'>
//                    <Link
//                        to="."
//                        style= {{ textDecoration: 'none' }}
//                    >
//                        <p className='textotherstyle'>Contrat HTH</p>
//                    </Link>
//                </div>
//                <div className='contratselectedmenustyle'>
//                    <Link
//                        to="kbis"
//                        style= {{ textDecoration: 'none' }}
//                    >
//                        <p className='textcardidstyle'>KBIS</p>
//                    </Link>
//                </div>
//            </div>
//            <div>
//                <Outlet />
//            </div>
//        </div>
//    );

